// extracted by mini-css-extract-plugin
export var container = "_eb-1";
export var cornerButtonContainer = "_eb-6";
export var disabled = "_eb-2";
export var dragActive = "_eb-3";
export var fileContainer = "_eb-5";
export var hiddenInput = "_eb-4";
export var widthContainer = "_eb-0";